import axios from "axios";

function formatDatetime() {
    const now = new Date();
    return now.toISOString().slice(0, 19).replace("T", " "); 
}

//Extracts an ad's URL from the HTML markup if it's embedded inside an `<a>` tag
const extractAdUrl = (adMarkup) => {
    if (!adMarkup || typeof adMarkup !== "string") return null;

    //Extract from `<a href="">`
    let match = adMarkup.match(/href=["'](https?:\/\/[^"']+)["']/);
    if (match) return match[1];

    //Extract from `<img src="">`
    match = adMarkup.match(/<img[^>]+src=["'](https?:\/\/[^"']+)["']/);
    if (match) return match[1];

    //Extract from `<script src="">`
    match = adMarkup.match(/<script[^>]+src=["'](https?:\/\/[^"']+)["']/);
    if (match) return match[1];

    //Extract direct script-based ad URL (`wrapper.src = "..."`)
    match = adMarkup.match(/wrapper\.src\s*=\s*["'](https?:\/\/[^"']+)["']/);
    if (match) return match[1];

    //Extract from `<noscript>` fallback tracking pixels
    match = adMarkup.match(/<noscript>.*?<img[^>]+src=["'](https?:\/\/[^"']+)["']/);
    if (match) return match[1];

    return null; // ❌ If no match is found, return `null`
};


async function storeAllBids(adUnitId, bids, topBid, auctionStartTime) { 
    if (bids.length === 0) return;

    const auctionId = bids[0].auctionId || "unknown"; 
    const winning_bidder_id = topBid?.bidder_id ?? null;

    try {
        const bidEntries = bids.map((bid) => ({
            //Auction Details
            auction_id: auctionId,
            ad_unit_code: adUnitId,
            start_time: auctionStartTime,
            highest_cpm: topBid.cpm || 0,
            winning_bidder_id,
            is_successful: bids.length > 0,

            //Bidder & Ad Details (No `bidder_id`, using `bidder_name` directly)
            bidder_name: bid.bidder || "unknown",
            prebid_adid: bid.adId || "none",
            creative_id: bid.creativeId || "none",
            ad_format: bid.mediaType || "banner",
            creative_width: bid.width || null,
            creative_height: bid.height || null,

            //Ensures ad_url is extracted if it's inside an `<a>` tag
            ad_url: bid.adUrl || extractAdUrl(bid.ad) || null,  
            media_url: bid.vastUrl || extractAdUrl(bid.ad) || null,  
            creative_attributes: JSON.stringify(bid.meta || {}),

            //Bid Metrics
            cpm: bid.cpm || 0,
            currency: bid.currency || "USD",
            response_time_ms: bid.responseTime || 0,
            is_winning_bid: bid.auction_id === topBid.auction_id && bid.cpm === topBid.cpm,
            impressions: 0,
            click_count: 0,
            viewability_score: null,
            timestamp: formatDatetime(),
        }));

        //Store all bids in a single request (Handles Auctions, Ads, and Bidders)
        await axios.post("/api/storeBids", { bids: bidEntries });

        //console.log(`[storeAllBids] Successfully stored ${bids.length} bids for auction ${auctionId}`);
    } catch (error) {
        console.error("[storeAllBids] Error:", error);
    }
}

export default storeAllBids;
